export default {
  heading: 'Noto Serif, serif',
  body: 'Noto Serif, serif',
  monospace: 'Menlo, monospace',
  display: 'Jim Nightshade, cursive',
  googleFonts: ['Noto Serif:400,700', 'Jim Nightshade']
  // customFamilies: ['', ''],
  // customUrls: ['', ''],
}
